import { RECEIPT_WITHOUT_TOKEN_VIEW } from '../utils/payment-receipt-view.util';
import { PaymentReceiptShell } from './payment-receipt-shell.component';
import { PaymentReceiptStatus } from './payment-receipt-status.component';

/**
 * Retorno da Autra sem o token da parcela: são os pedidos criados quando a
 * página de retorno do produto estava preenchida com `/payment`. Sem token não
 * há comprovante, então a página não mostra dados do seguro, só tranquiliza o
 * segurado no lugar do 404.
 */
export function PaymentReceiptWithoutTokenPage() {
  const { tone, title, message } = RECEIPT_WITHOUT_TOKEN_VIEW;

  return (
    <PaymentReceiptShell>
      <PaymentReceiptStatus tone={tone} title={title} message={message} />
      <p className='text-center text-xs leading-relaxed text-alba-gray-500'>
        Dúvidas sobre o seu seguro? Fale com a sua corretora.
      </p>
    </PaymentReceiptShell>
  );
}
